import WorkcalendarForm from "./WorkcalendarForm";
import WorkcalendarList from "./WorkcalendarList";
import WorkcalendarsPage from "./WorkcalendarsPage";

export default {
    list: WorkcalendarsPage,
    create: WorkcalendarsPage,
};